module.exports = __webpack_public_path__ + "static/img/referrals.8fd282b.png";


//////////////////
// WEBPACK FOOTER
// ./static/appicons/referrals.png
// module id = 1132
// module chunks = 0